import Vue from 'vue'
const radiosUser = new Vue()
export default radiosUser